// extracted by mini-css-extract-plugin
export default {"formWrapper":"domestic_formWrapper__O-tkd","rowWrapper":"domestic_rowWrapper__hGJ8g","fxRate":"domestic_fxRate__6b1rO"};